var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCustomerReturn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b4b4b4",
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1107 -4722)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1107, 4722)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)",
    fill: "#e27634",
    stroke: "#e4e4e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1121.5 4733.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 8,
    transform: "translate(0.5 0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,9.844a6.328,6.328,0,1,0,6.328,6.328A6.324,6.324,0,0,0,21.8,9.844Zm2.813,6.6a.43.43,0,0,1-.426.426H21.52a.43.43,0,0,1-.426-.426V13.083a.43.43,0,0,1,.426-.426h.554a.43.43,0,0,1,.426.426v2.386h1.683a.43.43,0,0,1,.426.426Zm-10.547-.277a7.707,7.707,0,0,1,.8-3.406,5.856,5.856,0,0,0-1.081-.11h-.734a7.65,7.65,0,0,1-6.407,0H5.906A5.908,5.908,0,0,0,0,18.562v1.828A2.11,2.11,0,0,0,2.109,22.5H17.363A7.734,7.734,0,0,1,14.062,16.172ZM9.844,11.25A5.625,5.625,0,1,0,4.219,5.625,5.625,5.625,0,0,0,9.844,11.25Z",
    transform: "translate(8.5 11.5)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomerReturn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CustomerReturn.8b8446dc.svg";
export { ForwardRef as ReactComponent };